import { useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../pages/App/routes";
import CustomButton from "../../UI/Buttons/CustomButton";
import Buildings from "../../UI/Icons/Buildings";
import Location from "../../UI/Icons/Location";

const enquiries = [
  {
    id: "1",
    name: "Valerie Lai",
    submittedDate: "2 Jan 2025",
    centres: [{ name: "Foxtrot Centre", location: "West Kentvale VIC" }],
  },
  {
    id: "2",
    name: "Valerie Lai",
    submittedDate: "2 Jan 2025",
    centres: [
      { name: "Kilo Lima Centre", location: "Farfette VIC" },
      { name: "Foxtrot Centre", location: "West Kentvale VIC" },
    ],
  },
];

const CentreEnquiries = ({ enquiry_count }: { enquiry_count: number }) => {
  const navigate = useNavigate();

  const handleViewClick = () => {
    navigate(AUTH_ROUTE.ADMIN_CENTERS);
  };

  return (
    <div className="border border-grey-light radius-8px p-10px d-flex flex-column gap-10">
      {/* Header */}
      <div className="d-flex gap-3 align-items-center justify-content-between">
        <div className="d-flex gap-3 align-items-center">
          <Buildings color="#51C2B9" />
          <div className="w-15px"></div>
          <div className="fs-45 fw-400 text-black">{enquiry_count}</div>
          <div className="w-5px" />
          <div className="fs-16 fw-700 text-black">
            Centre Enquiries To Review
          </div>
        </div>
        <CustomButton
          variant={"primary"}
          type="button"
          className="btn-theme bg-off-white text-black max-h-30px"
          onClick={handleViewClick}
        >
          View
        </CustomButton>
      </div>

      {/* Enquiry Cards */}
      {/* {enquiries.map((enquiry) => (
        <div
          key={enquiry.id}
          className="bg-white border border-off-white radius-8px py-8px px-10px"
        >
          <div className="flex-grow-1 d-flex flex-column flex-lg-row gap-10 align-items-lg-center text-break">
            <div className="flex-grow-1 d-flex flex-column gap-3">
              <div className="d-flex gap-5 align-items-center flex-wrap">
                <div className="fs-16 fw-700 text-black">{enquiry.name}</div>
                <div className="fs-13 fw-400 text-grey-medium">
                  Submitted {enquiry.submittedDate}
                </div>
              </div>
              {enquiry.centres.map((centre, idx) => (
                <div
                  key={`${enquiry.id}-centre-${idx}`}
                  className="d-flex gap-5 align-items-center flex-wrap"
                >
                  <div className="fs-13 fw-400 text-black">{centre.name}</div>
                  <div className="d-flex gap-5 align-items-center">
                    <Location size={16} />
                    <div className="fs-13 fw-400 text-black">
                      {centre.location}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <CustomButton
              variant={"primary"}
              type="button"
              className="btn-theme bg-off-white text-black max-h-30px min-w-76px"
            >
              View
            </CustomButton>
          </div>
        </div>
      ))} */}
    </div>
  );
};

export default CentreEnquiries;
